import { render } from "./App.vue?vue&type=template&id=65ae8430"
const script = {}

import "./App.vue?vue&type=style&index=0&id=65ae8430&lang=scss"

import exportComponent from "E:\\2023project\\检测开放服务平台\\检测服务平台官网\\kindstar-openapi-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__